module.exports = __webpack_public_path__ + "img/icon-support-2.4aadfb4f.svg";